import styled from 'styled-components'
import { ControlSize } from 'types'
import { heightFromControlSize } from 'utils'
import AvatarComponent from './avatar'
import InputComponent from './input'

export const Avatar = styled(AvatarComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

export const Input = styled(InputComponent)<{ $size: ControlSize }>`
    box-sizing: border-box;
    padding-left: ${({ $size }) => heightFromControlSize($size)}px;
    position: relative;

    input {
        padding-left: 0.5em;
    }
`
